module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Code/Puzzle-a9063899fa145d980f49c97b8f0339f267547c930b53bbc0c0f97747c8948194.svg";